"use client";

import { Control } from "react-hook-form";

import ImageUploader from "@/components/common/forms/ImageUploader";
import { SellCarFormSchemaType } from "@/schemas/validation/sellCarFormSchema";

interface SecondStepProps {
  control: Control<SellCarFormSchemaType>;
}

// Example usage in your form
const SecondStep = ({ control }: SecondStepProps) => {
  return (
    <div className="mt-10">
      <div className="mt-4">
        <ImageUploader name="images" control={control} required label="Upload your images" maxImages={6} />
      </div>
    </div>
  );
};

export default SecondStep;
